import React from "react";
import { Trans } from "react-i18next";

import { CompassColor, Link, Text } from "@noom/wax-component-library";

export const ProgramEligibilityFooter: React.FC = () => {
  const supportLink = (
    <Link
      color={CompassColor.white}
      href="mailto:partnersupport@noom.com"
      textDecoration="underline"
    >
      partnersupport@noom.com
    </Link>
  );

  return (
    <Text color={CompassColor.white} fontSize="14px" lineHeight="18px">
      <Trans
        i18nKey="programEligibilityFooter.footer"
        components={{
          supportLink,
        }}
      />
    </Text>
  );
};
